import React, { Component } from 'react';
import Select from 'react-select';

class PaymentsComponent extends Component {
    onChangeDriver = async (event) => {
        const { props } = this.props
        const { searchData, refreshSearch } = props
        let value = null
        if (event && event.value !== undefined) {
            value = event.value;
        }
        else if (event && event.nativeEvent && event.nativeEvent.target) {
            value = event.nativeEvent.target.value;
        }
        searchData.driver = value;
        refreshSearch(searchData);
    }

    onChangeDateFrom = (e) => {
        const { searchData, refreshSearch } = this.props;
        searchData.dateFrom = e.target.value || null;
        refreshSearch(searchData);
    };
    onChangeDateTo = (e) => {
        const { searchData, refreshSearch } = this.props;
        searchData.dateTo = e.target.value || null;
        refreshSearch(searchData);
    };

    onSearch = () => {
        const { searchData, search } = this.props;
        search(searchData);
    };

    render() {
        const { listDrivers = [], searchData } = this.props;
        return (
            <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
                <div className="form-group d-flex align-items-center mb-2 mr-3" style={{ minWidth: 240 }}>
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Chofer</span>
                    </div>
                    <Select
                        options={listDrivers}
                        value={listDrivers.find(b => b.value === searchData?.driver) || null}
                        onChange={this.onChangeDriver}
                        placeholder="Seleccionar Chofer..."
                        isSearchable
                        isClearable
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => 'No se encontraron coincidencias'}
                        styles={{
                            container: (base) => ({ ...base, flex: 1, width: 320 }),
                            control: (base) => ({ ...base, height: 39, minHeight: 39, borderRadius: 4, backgroundColor: "transparent", borderColor: "#ced4da", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }),
                            menu: (base) => ({ ...base, zIndex: 9999 }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0, color: "#000" }),
                            singleValue: (base) => ({ ...base, color: "#000" })
                        }}
                    />
                </div>

                <div className="form-group d-flex align-items-center mb-2 mr-3">
                    <label className="mb-0 mr-2">
                        <strong>Desde:</strong>
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        style={{
                            height: 44,
                            borderRadius: 12,
                            backgroundColor: '#f9fafb',
                            width: 180
                        }}
                        value={searchData?.dateFrom || ''}
                        onChange={this.onChangeDateFrom}
                    />
                </div>

                <div className="form-group d-flex align-items-center mb-2 mr-3">
                    <label className="mb-0 mr-2">
                        <strong>Hasta:</strong>
                    </label>
                    <input
                        type="date"
                        className="form-control"
                        style={{
                            height: 44,
                            borderRadius: 12,
                            backgroundColor: '#f9fafb',
                            width: 180
                        }}
                        value={searchData?.dateTo || ''}
                        onChange={this.onChangeDateTo}
                    />
                </div>


                <div className="form-group d-flex align-items-center mb-2 mr-3">
                    <button
                        className="btn botonCorrect text-white"
                        style={{
                            height: 44,
                            padding: '0 24px',
                            borderRadius: 12,
                            boxShadow: '0 8px 20px rgba(234,191,40,.25)'
                        }}
                        onClick={this.onSearch}
                    >

                        Buscar
                        <i className="fas fa-search ml-2" />
                    </button>
                </div>

                <div className="form-group d-flex align-items-center mb-2 mr-3">
                    <button className="btn secondary-action"
                        data-toggle="modal"
                        data-target="#voucherUploadModal"
                        style={{
                            height: 44,
                            padding: '0 24px',
                            borderRadius: 12,
                        }}>
                        Agregar Vouchers
                        <i className="far fa-file-alt ml-2" />
                    </button>
                </div>

            </div>
        );
    }
}

export default PaymentsComponent;
